import { useSearchParams } from '@app/common/utils/url/useSearchParams';

import { WizardResultRouterState } from '../types';

/**
 * Retrieves the URL search parameters and returns an object with two properties: `isSuccess` and `message`.
 * The `isSuccess` property is a boolean indicating whether the value of the `isSuccess` parameter in the URL is "true".
 * The `message` property is a string value obtained from the `message` parameter in the URL, after decoding it.
 * @returns {WizardResultRouterState} An object with `isSuccess` (boolean) and `message` (string) properties.
 */
export const useWizardResultRouterUrlState = (): WizardResultRouterState => {
  const params = useSearchParams();

  const isSuccess = params.get('isSuccess') === 'true';
  // eslint-disable-next-line i18next/no-literal-string
  const message = decodeURIComponent(params.get('message') || '');
  return {
    isSuccess,
    message,
  };
};
